<template>
  <div>
    <div class="app-title">
      <em-view-title :crudState="$_emWorkflowListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content">
      <div id="accordionFilter" class="content" v-menu-permission="'list'">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" :query-api="$_emWorkflowListMixin_queryApi" ref="emListFilter"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="emArchToolChangeResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName" inlineActionsDisabled :query-api="$_emWorkflowListMixin_queryApi"
                        :ref="modelName+'Table'" exportDisabled withCustomRowActions
                        with-custom-row-actions-first-column>
                <template slot="left-header">
                  <em-button type="search"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :customLabel="isClaim ? '认领' : '待办'"
                             :custom-icon="'fa ' + (isClaim ? 'fa-toggle-on' : 'fa-toggle-off')"
                             :busy="emWorkflowListLoading"
                             show-name
                             @click="switchClaim">
                  </em-button>
                </template>
                <template slot="customRowActionsFirstColumn" slot-scope="customRowScope">
                  <em-button type="task"
                             :busy="claimLoading"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             :custom-label="isClaim ? '认领' : '处理'"
                             @click="handleExecute(customRowScope.row)">
                  </em-button>
                  <em-button type="gotoChild"
                             v-bind:class="'btn btn-outline-primary btn-sm'"
                             custom-icon="fa fa-fw fa-lg fa-link"
                             custom-label="选择当前申请需要的工具"
                             @click="selectTools(customRowScope.row)">
                  </em-button>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <sub-entity-list ref="spaEntityList" sub-entity="emArchToolChangeDetail"
                     parent-field="changeFlowId"></sub-entity-list>
  </div>
</template>
<script>
// Author SWL
// Date 2022-03-31 18:13:36
import emWorkflowListMixin from "@/mixin/em/workflow/list";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import EmCommonApi from "@/mixin/em/common/api";
import subEntityList from "@/components/em/EmModal/SubEntityList";

export default {
  name: "emArchToolChangeWorkflowListView",
  mixins: [emWorkflowListMixin, emCommonGotoMixin, EmCommonApi],
  components: {subEntityList},
  computed: {
    modelName() {
      return this.$_emRouterHelperMixin_entityName
    },
    $_emRouterHelperMixin_pathType() {
      return this.isClaim ? 'claim' : this.$route.query.pathType;
    },
    pathType() {
      return this.$route.query.pathType;
    },
  },
  watch: {
    pathType() {
      this.isClaim = false;
    }
  },
  data() {
    return {
      isClaim: false,
      claimLoading: false,
    }
  },
  methods: {
    switchClaim() {
      this.isClaim = !this.isClaim;
    },
    handleExecute(row) {
      console.log(row)
      if (this.isClaim) {
        if (row.workflowTask && row.workflowTask.processDefinitionKey) {
          this.claimLoading = true;
          this.$store.dispatch('api/post', {
            url: this.$store.state.emArchToolChange.baseModuleUrl + "/emArchToolChange/claimTask",
            data: {
              processDefinitionKey: row.workflowTask.processDefinitionKey,
              businessKeyList: [row.id]
            }
          }).then(() => {
            this.claimLoading = false;
            this.$message.success("认领成功");
            this.$_emWorkflowListMixin_init();
          });
        }
      } else {
        this.$_emWorkflowListMixin_handleApprove(row);
      }
    },
    selectTools(row) {
      this.$refs.spaEntityList.showModal(row.id);
    }
  },
  mounted() {
    if (this.$route.query.toClaim) {
      this.isClaim = true;
    }
    if (this.$route.query.hasOwnProperty('processId')) {
      this.$nextTick(() => {
        this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('idFilter', this.$route.query.processId);
        this.$refs.emListFilter.doQuery();
      })
    }
  },
};
</script>